<div *ngIf="supplier" class="flex-fill full-width d-flex flex-row flex-wrap align-items-center justify-content-end m-1">
    <i class="fas fa-exclamation-triangle text-danger" *ngIf="sharedDataSvc.apiSirenLastError"
        data-toggle="tooltip" [title]="sharedDataSvc.apiSirenLastError"
        ></i>
    <div class="d-flex flex-row justify-content-end  align-items-center mx-1" style="max-width:400px;">
        <div class="d-flex flex-row justify-content-end align-items-center">
            <h4 class="mb-0 d-flex flex-column">
                <supplier-statut-badge [supplierStatutId]="supplier?.StatutId" [size]="badgeSize"></supplier-statut-badge>
            </h4>
            <button *ngIf="suspensionBtn" type="button" [paflabel]="suspensionBtn.BtnLib" class="btn btn-xs ml-1"
                [ngClass]="suspensionBtn.BtnClass" (click)="btnChangeStatutClic(suspensionBtn,1)"></button>
            <button *ngIf="reactivationBtn" type="button" [paflabel]="reactivationBtn.BtnLib" class="btn btn-xs ml-1"
                [ngClass]="reactivationBtn.BtnClass" (click)="btnChangeStatutClic(reactivationBtn,1)"></button>
            <btn-delete-supplier [supplierId]="supplier?.Id"
                [btnClass]="'btn-xs btn-danger ml-1'"></btn-delete-supplier>
        </div>
    </div>
    <num-tiers [supplier]="supplier" class="m-1"></num-tiers>
    <div *ngIf="sharedDataSvc.portalType=='INTRANET'"
        class="d-flex justify-content-end mb-1 mr-1 align-items-center flex-wrap">
        <span *ngFor="let b of nextButtons" class="d-flex flex-column">
            <button *ngIf="buttonsVisible && !b.IsSuspensionBtn && !b.IsReactivationBtn" type="button"
                [paflabel]="b.BtnLib" class="ml-1" [ngClass]="b.BtnClass"
                [disabled]="b.IsValidationBtn==1 && validationdisabled" (click)="btnChangeStatutClic(b,1)"></button>
        </span>
        <history-button [supplierId]="supplier.Id" btnClass=" btn-xs btn-info ml-1"></history-button>
    </div>
</div>

<kendo-window [(state)]="windowsValid.state" *ngIf="windowsValid.visible && clickedButton"
    [(width)]="windowsValid.width" [top]="50" [(height)]="windowsValid.height" (close)="showWindowsValid(false)">

    <kendo-window-titlebar [ngClass]="pafCssHeader">
        <div class="k-window-title text-center">
            <paflabel class="control-label" [lblCod]="getWindowsValidTitle()"></paflabel>
        </div>
        <button kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <div class="d-flex flex-column justify-content-center" style="height:100%;width:100%;">
        <div class="card">
            <div class="card-body">
                <form id="frmvalidstatut" name="frmvalidstatut" #ngfrmvalidstatut="ngForm">
                    <div *ngIf="currentCod=='250' && buttonCod=='VALIDATION'" class="row">
                        <div class="col-3">
                            <label class="control-label" paflabel="Coeur_de_metier"></label> :
                        </div>
                        <div class="col-9" *ngIf="mainFamily">
                            <input type="text" class="form-control" id="mainFamily" name="mainFamily"
                                [value]="getFamilyDisplay(mainFamily, true)" disabled required>
                            <validation-errors [form]="ngfrmvalidstatut" controlName="mainFamily"></validation-errors>
                        </div>
                    </div>
                    <div *ngIf="(currentCod=='550' || currentCod=='560') && buttonCod=='VALIDATION'" class="row">
                        <div class="col-3">
                            <label class="control-label" paflabel="Numero_SAP"></label>
                        </div>
                        <div class="col-9">
                            <input type="text" class="form-control" id="numTiers" name="numTiers" maxlength="16"
                                [(ngModel)]="supplier.NumTiers" required>
                            <validation-errors [form]="ngfrmvalidstatut" controlName="numTiers"></validation-errors>
                        </div>
                    </div>
                    <div class="row mt-3" *ngIf="lstButtonMotifs.length>0">
                        <div class="col-3">
                            <label class="control-label" paflabel="Motif"></label>
                        </div>
                        <div class="col-9">
                            <div class="full-width d-flex flex-column align-items-stretch justify-content-center">
                                <select class="form-control" name="codMotifSel" [(ngModel)]="codMotifSel" required>
                                    <option *ngFor="let motif of lstButtonMotifs" [value]="motif.Cod"
                                        [paflabel]="motif.LblCod"></option>
                                </select>
                                <validation-errors [form]="ngfrmvalidstatut"
                                    controlName="codMotifSel"></validation-errors>
                                <label class="mt-1 text-warning" *ngIf="selectedMotif?.Impact">Impact :
                                    {{selectedMotif?.Impact}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-3">
                            <label class="control-label" paflabel="Commentaire"></label>
                        </div>
                        <div class="col-9">
                            <textarea style="width:100%;height:120px;" class="form-control" name="comments"
                                [(ngModel)]="changeStatutParams.Comments" [required]="commentsRequired"></textarea>
                        </div>
                        <validation-errors [form]="ngfrmvalidstatut" controlName="comments"></validation-errors>
                    </div>
                </form>
            </div>
        </div>
        <div style="width:100%;" class="text-center my-2">
            <button type="button" paflabel="Valider" class="btn btn-sm btn-primary mx-1"
                (click)="btnChangeStatutClic(clickedButton,2)"></button>
            <button type="button" paflabel="Annuler" class="btn btn-sm btn-secondary mx-1"
                (click)="showWindowsValid(false)"></button>
        </div>
    </div>
    <!-- <PRE *ngIf="sharedDataSvc.debug">
        lstButtonMotifs : {{lstButtonMotifs | json}}
    </PRE> -->
</kendo-window>